import { Link } from "@/components/common/Link";
import { Card, CardContent, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
const events = [{
  id: 1,
  title: "Kopdar Rutin Bulanan",
  date: "KOPDAR",
  description: "Pertemuan rutin antar driver untuk mempererat tali silaturahmi dan berbagi informasi terkini di jalanan.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/kopdar_driver_community.png",
  link: "/berita/"
}, {
  id: 2,
  title: "Aksi Solidaritas Driver",
  date: "SOLIDARITAS",
  description: "Kegiatan gotong royong membantu rekan driver yang sedang mengalami musibah atau kendala teknis.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/solidaritas_driver_aksi.png",
  link: "/berita/"
}, {
  id: 3,
  title: "Santunan Anak Yatim",
  date: "SANTUNAN",
  description: "Program kepedulian sosial komunitas dengan berbagi kebahagiaan bersama anak-anak yang membutuhkan.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/santunan_sosial_driver.png",
  link: "/berita/"
}, {
  id: 4,
  title: "Touring Kemerdekaan",
  date: "TOURING",
  description: "Perjalanan bersama lintas kota untuk merayakan semangat kebersamaan dan jiwa nasionalisme.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/touring_driver_bersama.png",
  link: "/berita/"
}, {
  id: 5,
  title: "Bakti Sosial Lingkungan",
  date: "SOLIDARITAS",
  description: "Aksi nyata komunitas driver dalam menjaga kebersihan lingkungan dan fasilitas umum di sekitar pangkalan.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/baksos_driver_lingkungan.png",
  link: "/berita/"
}, {
  id: 6,
  title: "Pelatihan Safety Driving",
  date: "KOPDAR",
  description: "Edukasi keselamatan berkendara untuk meningkatkan profesionalisme dan keamanan driver saat bertugas.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/safety_driving_training.png",
  link: "/berita/"
}];
export default function KomunitasDriver() {
  return <section data-section-id="256293" id="komunitas-driver" className="py-20 bg-background text-foreground relative overflow-hidden">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-5xl h-px bg-gradient-to-r from-transparent via-primary/50 to-transparent"></div>
      
      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="flex flex-col items-center mb-16">
          <h2 className="text-3xl md:text-4xl font-default font-bold uppercase tracking-widest text-center mb-4 text-foreground">
            Kegiatan Komunitas
          </h2>
          <div className="flex items-center gap-4 w-full max-w-md opacity-80">
            <div className="h-px bg-primary flex-grow"></div>
            <div className="w-2 h-2 bg-primary rotate-45"></div>
            <div className="h-px bg-primary flex-grow"></div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {events.map((event, i) => <Card key={event.id} data-index={i} className="bg-card border border-border rounded-lg overflow-hidden flex flex-col shadow-sm hover:shadow-md hover:scale-[1.03] transition-all duration-300 group">
              <div className="relative aspect-square overflow-hidden bg-muted border-b border-border">
                <img src={event.image} alt={`Flyer for ${event.title}`} data-wvc-srcset={`${event.image}-wvc-srcset`} data-wvc-sizes={`${event.image}-wvc-sizes`} className="object-cover w-full h-full transition-transform duration-700 group-hover:scale-105" loading="lazy" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent opacity-80"></div>
              </div>
              
              <CardContent className="p-5 flex-grow flex flex-col gap-3 relative z-10 -mt-8">
                <div className="inline-flex items-center justify-center bg-primary text-primary-foreground text-xs font-default font-bold tracking-wider py-1 px-3 rounded-md w-fit shadow-sm">
                  {event.date}
                </div>
                <h3 className="text-base font-default font-bold leading-tight text-foreground mt-2">
                  {event.title}
                </h3>
                <p className="text-muted-foreground text-sm leading-relaxed line-clamp-3">
                  {event.description}
                </p>
              </CardContent>
              
              <CardFooter className="p-5 pt-0 mt-auto">
                <Button asChild variant="outline" className="w-full bg-transparent border-primary text-primary hover:bg-primary hover:text-primary-foreground transition-colors duration-300 font-bold tracking-wide uppercase text-xs rounded-md">
                  <Link to={event.link}>Lihat Kegiatan</Link>
                </Button>
              </CardFooter>
            </Card>)}
        </div>
      </div>
    </section>;
}